import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FeatureGate } from "@/components/FeatureGate";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, AlertTriangle } from "lucide-react";
import { brl } from "@/lib/format";
import { toast } from "sonner";

export default function Inventory() {
  return <FeatureGate feature="inventory_basic" title="Estoque disponível a partir do plano Essencial"><Inner /></FeatureGate>;
}

function Inner() {
  const [items, setItems] = useState([]);
  const [dlg, setDlg] = useState(false);
  const [f, setF] = useState({ name: "", unit: "un", current: 0, minimum: 0, cost: 0 });
  const load = async () => setItems((await api.get("/inventory")).data);
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.post("/inventory", { ...f, current: parseFloat(f.current), minimum: parseFloat(f.minimum), cost: parseFloat(f.cost) });
      toast.success("Item cadastrado"); setDlg(false); setF({ name: "", unit: "un", current: 0, minimum: 0, cost: 0 }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  return (
    <div className="space-y-6" data-testid="inventory-page">
      <div className="flex items-center justify-between">
        <div><h1 className="font-display text-3xl font-extrabold text-stone-900">Estoque</h1>
          <p className="text-stone-500">Matérias-primas e insumos.</p></div>
        <Dialog open={dlg} onOpenChange={setDlg}>
          <DialogTrigger asChild><Button className="gap-2 bg-orange-600 hover:bg-orange-700" data-testid="new-inv-btn"><Plus className="h-4 w-4" /> Novo item</Button></DialogTrigger>
          <DialogContent><DialogHeader><DialogTitle>Novo item</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nome</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="inv-name" /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Unidade</Label>
                  <select className="w-full h-10 rounded-md border border-input bg-background px-3 text-sm" value={f.unit} onChange={(e) => setF({ ...f, unit: e.target.value })}>
                    <option value="un">Unidade</option><option value="kg">Kg</option><option value="g">Grama</option><option value="l">Litro</option><option value="ml">ml</option>
                  </select></div>
                <div><Label>Custo (R$)</Label><Input type="number" step="0.01" value={f.cost} onChange={(e) => setF({ ...f, cost: e.target.value })} /></div>
                <div><Label>Estoque atual</Label><Input type="number" step="0.01" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="inv-current" /></div>
                <div><Label>Estoque mínimo</Label><Input type="number" step="0.01" value={f.minimum} onChange={(e) => setF({ ...f, minimum: e.target.value })} /></div>
              </div>
            </div>
            <DialogFooter><Button onClick={save} className="bg-orange-600 hover:bg-orange-700" data-testid="inv-save">Salvar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((i) => {
          const low = i.current <= i.minimum;
          return (
            <Card key={i.id} className="rounded-2xl" data-testid={`inv-${i.id}`}>
              <CardContent className="p-5">
                <div className="flex items-center justify-between">
                  <div className="font-display font-bold text-stone-900">{i.name}</div>
                  {low && <div className="inline-flex items-center gap-1 text-xs text-rose-600 font-semibold"><AlertTriangle className="h-3.5 w-3.5" /> Baixo</div>}
                </div>
                <div className="mt-3 flex items-baseline gap-2">
                  <span className="font-mono-num text-2xl font-extrabold">{i.current}</span>
                  <span className="text-sm text-stone-500">{i.unit}</span>
                </div>
                <div className="text-xs text-stone-500 mt-1">Mínimo: {i.minimum} {i.unit} • Custo: {brl(i.cost)}</div>
              </CardContent>
            </Card>
          );
        })}
        {items.length === 0 && <Card className="col-span-full"><CardContent className="p-6 text-center text-stone-500">Cadastre seu primeiro item de estoque.</CardContent></Card>}
      </div>
    </div>
  );
}
